export default __webpack_public_path__ + "static/media/compas_project_formation_alacarte.c46b94f5.gif";